import { api } from "../lib/axios"

export async function MainBannerFn() {
  const response = await api.get('mainBanners')

  return response.data
}